/**
 * Global axios setup: credentials + bearer fallback.
 * Reads access_token from localStorage (set by AuthContext after login)
 * so auth still works when SameSite=None cookies are blocked.
 */
import axios from "axios";

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("access_token");
    if (token && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {}
  return config;
});
